const ENV = {
  NOTIFICATION_DURATION: 3000 // time in ms
}

export const CONTACT_EVENTS = ['contact_mail', 'contact_phone', 'contact_visit']

export default ENV
